import { Claude, Copilot, DeepSeek, Gemini, Grok, Meta, OpenAI, Perplexity, Qwen } from "@lobehub/icons";

interface AIProviderCardProps {
  icon: React.ComponentType<{ className?: string; size?: number; type?: "color" | "mono" | undefined }>;
  iconType?: "color" | "mono" | undefined;
}

function AIProviderCard({ icon: Icon, iconType }: AIProviderCardProps) {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-lg border border-gray-300/90 shadow-sm hover:shadow-md transition-shadow w-12 h-12 flex items-center justify-center">
      <Icon className="w-6 h-6" size={24} type={iconType} />
    </div>
  );
}

export default function AIProviderGrid() {
  const providers = [
    { icon: OpenAI, type: undefined },
    { icon: Perplexity.Color, type: "color" as const },
    { icon: Copilot.Color, type: "color" as const },
    { icon: Claude.Color, type: "color" as const },
    { icon: Grok, type: undefined },
    { icon: DeepSeek.Color, type: "color" as const },
    { icon: Gemini.Color, type: "color" as const },
    { icon: Meta.Color, type: "color" as const },
    { icon: Qwen.Color, type: "color" as const },
  ];

  return (
    <div className="pt-6">
      <p className="text-sm font-medium text-muted-foreground mb-2">Monitor every AI provider on all plans</p>
      <div className="flex flex-wrap gap-2">
        {providers.map((provider, index) => (
          <AIProviderCard key={index} icon={provider.icon} iconType={provider.type} />
        ))}
      </div>
    </div>
  );
}
